<template>
  <div class="wrapper">
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 0.96875C8.20312 0.96875 9.35156 1.29688 10.3906 1.89844C11.4297 2.5 12.25 3.32031 12.8516 4.35938C13.4531 5.39844 13.7812 6.54688 13.7812 7.75C13.7812 8.98047 13.4531 10.1016 12.8516 11.1406C12.25 12.1797 11.4297 13.0273 10.3906 13.6289C9.35156 14.2305 8.20312 14.5312 7 14.5312C5.76953 14.5312 4.64844 14.2305 3.60938 13.6289C2.57031 13.0273 1.72266 12.1797 1.12109 11.1406C0.519531 10.1016 0.21875 8.98047 0.21875 7.75C0.21875 6.54688 0.519531 5.39844 1.12109 4.35938C1.72266 3.32031 2.57031 2.5 3.60938 1.89844C4.64844 1.29688 5.76953 0.96875 7 0.96875ZM7 3.97656C6.67188 3.97656 6.39844 4.11328 6.17969 4.33203C5.96094 4.55078 5.85156 4.82422 5.85156 5.125C5.85156 5.45312 5.96094 5.72656 6.17969 5.94531C6.39844 6.16406 6.67188 6.27344 7 6.27344C7.30078 6.27344 7.57422 6.16406 7.79297 5.94531C8.01172 5.72656 8.14844 5.45312 8.14844 5.125C8.14844 4.82422 8.01172 4.55078 7.79297 4.33203C7.57422 4.11328 7.30078 3.97656 7 3.97656ZM8.53125 10.9219V10.2656C8.53125 10.1836 8.47656 10.1016 8.42188 10.0469C8.36719 9.99219 8.28516 9.9375 8.20312 9.9375H7.875V7.20312C7.875 7.12109 7.82031 7.03906 7.76562 6.98438C7.71094 6.92969 7.62891 6.875 7.54688 6.875H5.79688C5.6875 6.875 5.60547 6.92969 5.55078 6.98438C5.49609 7.03906 5.46875 7.12109 5.46875 7.20312V7.85938C5.46875 7.96875 5.49609 8.05078 5.55078 8.10547C5.60547 8.16016 5.6875 8.1875 5.79688 8.1875H6.125V9.9375H5.79688C5.6875 9.9375 5.60547 9.99219 5.55078 10.0469C5.49609 10.1016 5.46875 10.1836 5.46875 10.2656V10.9219C5.46875 11.0312 5.49609 11.1133 5.55078 11.168C5.60547 11.2227 5.6875 11.25 5.79688 11.25H8.20312C8.28516 11.25 8.36719 11.2227 8.42188 11.168C8.47656 11.1133 8.53125 11.0312 8.53125 10.9219Z"
        fill="#5C5F62"
      />
    </svg>
    <p class="text">
      {{ message }}
    </p>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.wrapper {
  display: flex;
  align-items: center;
  padding: 1rem;
  border: 1px solid #babfc3;
  background-color: #f6f6f7;
  border-radius: 4px;
  margin-bottom: 1rem;
}

.text {
  margin-left: 1rem;
  font-size: 0.875rem;
  color: #202223;
}
</style>
